import { tracker } from '../track';
export const trackDeSelectCalendarAlert = (element, campaignId) => {
    const deselectContent = {
        element,
        promotion_id: campaignId,
    };
    tracker.track('GA4-deselect_calendar_alert', {
        event_name: 'deselect_calendar_alert',
        deselect_calendar_alert: deselectContent,
    });
};
